import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-14bd57af"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "time-slot-by-day" }
const _hoisted_2 = { class: "flex items-center gap-5 text-sm font-semibold" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "16",
  height: "15",
  viewBox: "0 0 16 15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M6.97664 0.72783C7.29875 -0.24261 8.70125 -0.24261 9.02336 0.727831L10.1742 4.19517C10.3183 4.62916 10.7314 4.923 11.1976 4.923H14.9219C15.9643 4.923 16.3977 6.22872 15.5544 6.82848L12.5413 8.97141C12.1642 9.23964 12.0064 9.71507 12.1505 10.1491L13.3013 13.6164C13.6234 14.5868 12.4888 15.3938 11.6455 14.7941L8.63247 12.6511C8.25534 12.3829 7.74466 12.3829 7.36753 12.6511L4.35449 14.7941C3.5112 15.3938 2.37655 14.5868 2.69866 13.6164L3.84954 10.1491C3.99359 9.71507 3.83579 9.23964 3.45866 8.97141L0.445614 6.82848C-0.397678 6.22872 0.035717 4.923 1.07808 4.923H4.80241C5.26857 4.923 5.68171 4.62916 5.82576 4.19517L6.97664 0.72783Z",
    fill: "#0F172A"
  })
], -1))
const _hoisted_4 = { class: "header__period" }
const _hoisted_5 = { class: "flex items-center gap-3" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M3.72353 13.6095C4.24423 14.1302 5.08845 14.1302 5.60915 13.6095L9.99967 9.21895L14.3902 13.6095C14.9109 14.1302 15.7551 14.1302 16.2758 13.6095C16.7965 13.0888 16.7965 12.2446 16.2758 11.7239L10.9425 6.39052C10.4218 5.86983 9.57756 5.86983 9.05686 6.39052L3.72353 11.7239C3.20283 12.2446 3.20283 13.0888 3.72353 13.6095Z",
  fill: "#0F172A"
}, null, -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = {
  key: 0,
  class: "time-slot-by-day__container"
}
const _hoisted_9 = { class: "mt-5 grid grid-cols-2 gap-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_time_slot_by_day_resources = _resolveComponent("time-slot-by-day-resources")!
  const _component_time_slot_by_day_sectors = _resolveComponent("time-slot-by-day-sectors")!
  const _component_time_slot_by_day_child = _resolveComponent("time-slot-by-day-child")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "time-slot-by-day__header",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggle && _ctx.toggle(...args)))
    }, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", null, _toDisplayString(_ctx.getPeriod(_ctx.format(_ctx.item.timeFrom), _ctx.format(_ctx.item.timeTo))), 1),
        _createElementVNode("div", {
          class: _normalizeClass(["header__status", { 'status--active': _ctx.item.status.id === 51, 'status--inactive': _ctx.item.status.id === 52 }])
        }, [
          (_ctx.item.status.id === 51)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode("Активный")
              ], 64))
            : (_ctx.item.status.id === 52)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode("Неактивный")
                ], 64))
              : _createCommentVNode("", true)
        ], 2),
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.item.periodGroupName), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(), _createElementBlock("svg", {
          class: _normalizeClass(["header__arrow", { 'arrow--rotate': !_ctx.state.is_opened }]),
          width: "20",
          height: "20",
          viewBox: "0 0 20 20",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, _hoisted_7, 2))
      ])
    ]),
    (_ctx.state.is_opened)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createVNode(_component_time_slot_by_day_resources, {
            usage: _ctx.item.usage,
            resources: _ctx.item.capacities
          }, null, 8, ["usage", "resources"]),
          _createVNode(_component_time_slot_by_day_sectors, {
            class: "mt-3",
            sectors: _ctx.item.sectors
          }, null, 8, ["sectors"]),
          _createElementVNode("div", _hoisted_9, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.item.children, (child) => {
              return (_openBlock(), _createBlock(_component_time_slot_by_day_child, {
                key: child.id,
                item: child,
                onChangeStatus: _ctx.onChangeStatusInChild
              }, null, 8, ["item", "onChangeStatus"]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}